var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.98999 22.78C9.38999 22.78 8.81999 22.48 8.42999 21.95L7.23001 20.35C7.23001 20.36 7.18 20.33 7.16 20.33H6.79001C3.37001 20.33 1.25 19.4 1.25 14.79V10.79C1.25 6.58001 3.82001 5.48001 5.98001 5.29001C6.22001 5.26001 6.50001 5.25 6.79001 5.25H13.19C16.81 5.25 18.73 7.17001 18.73 10.79V14.79C18.73 15.08 18.72 15.36 18.68 15.63C18.5 17.76 17.4 20.33 13.19 20.33H12.79L11.55 21.95C11.16 22.48 10.59 22.78 9.98999 22.78ZM6.79001 6.75C6.56001 6.75 6.34 6.76 6.13 6.78C3.81 6.98 2.75 8.25001 2.75 10.79V14.79C2.75 18.22 3.81001 18.83 6.79001 18.83H7.19C7.64 18.83 8.14999 19.08 8.42999 19.44L9.63 21.05C9.85001 21.35 10.13 21.35 10.35 21.05L11.55 19.45C11.84 19.06 12.3 18.83 12.79 18.83H13.19C15.73 18.83 17 17.76 17.19 15.48C17.22 15.24 17.23 15.02 17.23 14.79V10.79C17.23 8.00001 15.98 6.75 13.19 6.75H6.79001Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99219 14.1904C9.43219 14.1904 8.99219 13.7404 8.99219 13.1904C8.99219 12.6404 9.44219 12.1904 9.99219 12.1904C10.5422 12.1904 10.9922 12.6404 10.9922 13.1904C10.9922 13.7404 10.5522 14.1904 9.99219 14.1904Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1875 14.1904C12.6275 14.1904 12.1875 13.7404 12.1875 13.1904C12.1875 12.6404 12.6375 12.1904 13.1875 12.1904C13.7375 12.1904 14.1875 12.6404 14.1875 13.1904C14.1875 13.7404 13.7375 14.1904 13.1875 14.1904Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.79688 14.1904C6.23687 14.1904 5.79688 13.7404 5.79688 13.1904C5.79688 12.6404 6.24687 12.1904 6.79688 12.1904C7.34687 12.1904 7.79688 12.6404 7.79688 13.1904C7.79688 13.7404 7.34687 14.1904 6.79688 14.1904Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.9396 16.29C17.7396 16.29 17.5396 16.21 17.3996 16.06C17.2396 15.9 17.1697 15.67 17.1997 15.45C17.2297 15.24 17.2396 15.02 17.2396 14.79V10.79C17.2396 8.00001 15.9897 6.75 13.1997 6.75H6.79963C6.56963 6.75 6.34966 6.76 6.13966 6.78C5.91966 6.81 5.68964 6.72999 5.52964 6.57999C5.36964 6.41999 5.27963 6.20001 5.29963 5.98001C5.47963 3.82001 6.58963 1.25 10.7996 1.25H17.1997C20.8197 1.25 22.7396 3.17001 22.7396 6.79001V10.79C22.7396 15 20.1697 16.1 18.0097 16.29C17.9797 16.29 17.9596 16.29 17.9396 16.29ZM6.91966 5.25H13.1896C16.8096 5.25 18.7297 7.17001 18.7297 10.79V14.66C20.4297 14.24 21.2297 12.99 21.2297 10.79V6.79001C21.2297 4.00001 19.9796 2.75 17.1896 2.75H10.7897C8.58965 2.75 7.34966 3.55 6.91966 5.25Z",
    fill: "#B0BECF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.196e9fef3962fd91e6fc6f6d366d03b3.svg";
export { ForwardRef as ReactComponent };